import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigResponse, ProductApi } from '../../../menu.interfaces';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalApiService implements ProductApi {

  constructor(private httpClient: HttpClient) { }

  public getProducts() {
    return this.httpClient.get<ConfigResponse>('assets/config/menu-config.json')
      .pipe(map((response) => response.families));
  }
}
